<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 10:17:48
 * @LastEditors: xgx
 * @LastEditTime: 2023-10-08 15:30:22
-->
<template>
  <div>
    <div class="head">
      <div style="display: flex; align-items: center">
        <div  class="back" @click="toBack"><a-icon type="arrow-left" /></div>
        <div style="font-size: 18px; color: #303133; font-weight: bold">
          &emsp;{{ isEdit ? "详细信息" : "新增征集" }}
        </div>
      </div>
      <el-button
       v-if="codeData.indexOf('163') != -1 && this.isCollectId"
        @click="exportList"
        type="primary"
        >导出意见清单</el-button
      >
    </div>
    <div class="top">
      <!-- <div class="log-box">
        <div
          @click="changeType(1)"
          :style="{ color: type == 1 ? '#1890FF' : '' }"
          class="log"
        >
          征集设置
        </div>
        <div
          @click="changeType(2)"
          :style="{ color: type == 2 ? '#1890FF' : '' }"
          class="log"
          v-if="isEdit && codeData.indexOf('162') != -1"
        >
          意见清单
        </div>
        <div
          @click="changeType(3)"
          :style="{ color: type == 3 ? '#1890FF' : '' }"
          class="log"
          v-if="isEdit && codeData.indexOf('164') != -1"
        >
          结果反馈
        </div>
      </div> -->
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="征集设置" name="first"></el-tab-pane>
        <el-tab-pane v-if="isEdit && codeData.indexOf('162') != -1" label="意见清单" name="second"></el-tab-pane>
        <el-tab-pane  v-if="isEdit && codeData.indexOf('164') != -1" label="结果反馈" name="third"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="content">
      <div v-show="type == 1">
        <el-form
          :model="collectForm"
          ref="collectForm"
          :rules="rules"
          :style="{height:heightTwo}"
          label-width="100px"
          class="demo-ruleForm zheng-ji"
        >
          <el-form-item  style="width:600px" label="征集主题" prop="collectTheme">
            <el-input 
              v-model="collectForm.collectTheme"
              placeholder="请输入征集主题"
            ></el-input>
          </el-form-item>
           <el-form-item  style="width:600px" label="是否显示">
            <div class="status">
              <el-radio v-model="collectForm.displayStatus" :label="1"
                >显示</el-radio
              >
              <el-radio v-model="collectForm.displayStatus" :label="0"
                >不显示</el-radio
              >
            </div>
          </el-form-item>
          <el-form-item  style="width:600px" label="征集时间" prop="collectTime">
            <div class="block">
              <el-date-picker
                @input="changeTime"
                style="width:100%"
                v-model="collectForm.collectTime"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期 时间"
                end-placeholder="结束日期 时间"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item  style="width:600px" prop="collectUnit" label="征集单位">
            <el-input
              v-model="collectForm.collectUnit"
              placeholder="请输入征集单位名称"
            ></el-input>
          </el-form-item>
          <el-form-item  style="width:600px" label="发布时间" prop="issueTime">
            <el-date-picker
               style="width:100%"
              v-model="collectForm.issueTime"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item  style="width:600px" label="附件上传" prop="name">
            <!-- <div style="display: flex;">
                                <el-input placeholder="支持pdf、docx、xlsx格式" v-model="collectForm.accessory">
                                    <div slot="append" >点击上传</div>
                                </el-input>
                                <div class="add-uplaod"><span class="icon-plus"></span></div>
                            </div> -->
            <div
              style="display: flex; margin-top: 10px"
              v-for="(item, index) in accessoryList"
              :key="index"
            >
              <el-input
                placeholder="支持pdf、docx、xlsx、zip、xls、doc、ppt、pptx格式"
                disabled
                v-model="accessoryList[index].name"
              >
                <el-upload
                  :before-upload="(file) => beforeUpload(file, index)"
                  slot="append"
                  :show-file-list="false"
                  :multiple="false"
                  action="#"
                >
                   <span  v-if="!accessoryList[index]">点击上传</span>
                   <i @click.stop="deletFile(index)" v-if="accessoryList[index]"   class="el-icon-delete"></i>
                </el-upload>
               
              </el-input>
              <div class="add-uplaod" v-if="index == 0" @click="addAccessory">
                <span class="icon-plus"></span>
              </div>
              <div class="add-uplaod" v-else @click="deleteAccessory(index)">
                <span class="icon-delete"></span>
              </div>
            </div>
          </el-form-item>
          <!-- <el-form-item label="征集内容" prop="remark">
            <el-input
              placeholder="请输入征集内容"
              v-model="collectForm.collectContent"
              type="textarea"
              :rows="8"
            >
            </el-input>
          </el-form-item> -->
          <el-form-item v-show="type == 1" label="征集内容">
            <uEditorWrap v-model="collectForm.collectContent"
                         @ready="ueditorReady"
                         editor-id="editor"
                         :config="uEditorConfig"
                         :editorDependencies="['ueditor.config.js','ueditor.all.js']"
                         style="min-height: 260px;width: 895px"/>
<!--              <Toolbar-->
<!--                :editor="editor"-->
<!--                :defaultConfig="toolbarConfig"-->
<!--                :mode="mode"-->
<!--                style="width: 800px; border: solid #f4f4f6 2px"-->
<!--              />-->
<!--              <Editor-->
<!--                style="-->
<!--                  width: 800px;-->
<!--                  height: 290px;-->
<!--                  overflow-y: hidden;-->
<!--                  padding: 10px;-->
<!--                  border: solid #f4f4f6 2px;-->
<!--                "-->
<!--                v-model="collectForm.collectContent"-->
<!--                :defaultConfig="editorConfig"-->
<!--                :defaultContent="jsonContent"-->
<!--                :mode="mode"-->
<!--                v-if="type == 1"-->
<!--                @onCreated="onCreated"-->
<!--              />-->
              <!-- <editor :richText="richText" @changeText="changeText"></editor> -->
            </el-form-item>
        </el-form>
        <div class="form-bottom zhenji-seting">
              <el-button
                :loading="loadingSubmint"
                v-if="codeData.indexOf('161') != -1"
                class="seting"
                @click="saveCollect"
                size="medium"
                type="primary"
                >保存</el-button
              >
            </div>
      </div>
      <div v-if="type == 2">
        <coententTable
          @onShowSizeChange="onShowSizeChange"
          :columns="columns"
          :pagination="pagination"
          :dataSource="dataSource"
          :loading="loading"
          :y="height"
          @handleSizeChange="handleSizeChange"
        >
        </coententTable>
      </div>
      <div v-show="type == 3">
        <el-form
          :model="collectFeedbackForm"
          ref="ruleForm"
          :rules="rulesTwo"
           :style="{height:heightTwo}"
          label-width="100px"
          class="demo-ruleForm zheng-ji"
        >
          <el-form-item style="width:600px" label="反馈标题" prop="feedbackTitle">
            <el-input
              v-model="collectFeedbackForm.feedbackTitle"
              placeholder="请输入反馈标题"
            ></el-input>
          </el-form-item>
          <el-form-item style="width:600px" label="征集单位" prop="collectUnit">
            <el-input
              placeholder="甘孜州某某单位名称"
              v-model="collectFeedbackForm.collectUnit"
              type="text"
            >
            </el-input>
          </el-form-item>
          <el-form-item style="width:600px" label="发布时间" prop="issueTime">
            <el-date-picker
              v-model="collectFeedbackForm.issueTime"
              style="width:100%"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item style="width:600px" label="附件上传" prop="name">
            <div
              style="display: flex; margin-top: 10px"
              v-for="(item, index) in feedbackAccessoryList"
              :key="index"
            >
              <el-input
                placeholder="支持pdf、docx、xlsx、zip、xls、doc、ppt、pptx格式"
                disabled
                v-model="feedbackAccessoryList[index].name"
              >
                <el-upload
                  :before-upload="(file) => beforeUploadTwo(file, index)"
                  slot="append"
                  :show-file-list="false"
                  :multiple="false"
                  action="#"
                >
                  点击上传
                </el-upload>
              </el-input>
              <div
                class="add-uplaod"
                v-if="index == 0"
                @click="addFeedbackAccessory"
              >
                <span class="icon-plus"></span>
              </div>
              <div
                class="add-uplaod"
                v-else
                @click="deleteFeedbackAccessory(index)"
              >
                <span class="icon-delete"></span>
              </div>
            </div>
          </el-form-item>
          <el-form-item v-show="type == 3" label="反馈内容" prop="feedbackDetails">
             <uEditorWrap v-model="collectFeedbackForm.feedbackDetails"
                         @ready="ueditorReadyTwo"
                         editor-id="editorTwo"
                         :config="uEditorConfigTwo"
                         :editorDependencies="['ueditor.config.js','ueditor.all.js']"
                         style="min-height: 260px;width: 895px"/>
              <!-- <Toolbar
                :editor="editorTwo"
                :defaultConfig="toolbarConfig"
                :mode="mode"
                style="width: 800px; border: solid #f4f4f6 2px"
              />
              <Editor
                style="
                  width: 800px;
                  height: 290px;
                  overflow-y: hidden;
                  padding: 10px;
                  border: solid #f4f4f6 2px;
                "
                v-model="collectFeedbackForm.feedbackDetails"
                :defaultConfig="editorConfig"
                :mode="mode"
                v-if="type == 3"
                @onCreated="onCreatedTwo"
              /> -->
              <!-- <editor :richText="richText" @changeText="changeText"></editor> -->
            </el-form-item>
        </el-form>
        <div class="form-bottom zhenji-seting">
              <el-button
              :loading="loadingSubmintTwo"
               v-if="codeData.indexOf('165') != -1 || codeData.indexOf('166') != -1"
                  class="seting"
                @click="saveFeedback()"
                size="medium"
                type="primary"
                >保存</el-button
              >
            </div>
      </div>
    </div>
    <el-dialog
      title="导出意见清单"
      :visible.sync="exportShow"
      width="600px"
      class="column-box"
      top="12%"
    >
      <div class="colum-title-box">
        <i style="margin-right: 8px" class="el-icon-info"></i
        >将导出当前征集中的全部意见内容
      </div>
      <el-form ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="名称设置">
          <el-input
            v-model="fileName"
            placeholder="请输入导出后下载保存的文件名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportShow = false">取 消</el-button>
        <el-button type="primary" @click="tihuan">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  opinionFindListPage,
  collectDetils,
  updateCollect,
  saveCollect,
  collectFeedback,
  addCollectFeedback,
  updateCollectFeedback,
  IsCollectOpinionListExport
} from "./solicitation_survey.js";
import coententTable from "@/components/coentent_table.vue";
import { uploadImg,uploadVideo } from "@/utils/common.js";
import { message } from "ant-design-vue";
// import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import uEditorWrap from "vue-ueditor-wrap";
export default {
  components: {
    coententTable,
    uEditorWrap
    // Editor,
    // Toolbar,
  },
  data() {
    let self = this;
    return {
      uEditorConfig: {
        // 配置UEditorPlus的惊天资源
        UEDITOR_HOME_URL: process.env.VUE_APP_Admin || '/admin/static/uEditor/',
        UEDITOR_CORS_URL: process.env.VUE_APP_Admin || '/admin/static/uEditor/',
        // 服务器统一请求接口路径
        serverUrl: process.env.VUE_APP_BASE_URL + "/site-service/m/cover/uploadImage"
        // 启用拖放上传
        , enableDragUpload: true
        // 启用粘贴上传
        , enablePasteUpload: true
        // 启用图片拉伸缩放
        , imageScaleEnabled: true
      },
       uEditorConfigTwo: {
        // 配置UEditorPlus的惊天资源
        UEDITOR_HOME_URL: process.env.VUE_APP_Admin || '/admin/static/uEditor/',
        UEDITOR_CORS_URL: process.env.VUE_APP_Admin || '/admin/static/uEditor/',
        // 服务器统一请求接口路径
        serverUrl: process.env.VUE_APP_BASE_URL + "/site-service/m/cover/uploadImage"
        // 启用拖放上传
        , enableDragUpload: true
        // 启用粘贴上传
        , enablePasteUpload: true
        // 启用图片拉伸缩放
        , imageScaleEnabled: true
      },
      type: 1,
      exportShow: false,
       rules: {
        collectTime: [
          { required: true, message: "请输入征集时间", trigger: "blur" },
        ],
        issueTime: [{ required: true, message: "请输入发布时间", trigger: "blur" }],
        collectUnit:[{ required: true, message: "请输入征集单位", trigger: "blur" }],
        collectTheme:[{ required: true, message: "请输入征集主题", trigger: "blur" }],
      },
      rulesTwo:{
        issueTime: [{ required: true, message: "请输入发布时间", trigger: "blur" }],
        collectUnit: [{ required: true, message: "请输入征集单位", trigger: "blur" }],
        feedbackTitle: [{ required: true, message: "请输入反馈标题", trigger: "blur" }],
      },
      fileName: "",
      loadingBox:false,
      collectForm: {},
      collectFeedbackForm: {},
      loadingSubmint: false,
      isEdit: false,
      editor:null,
      editorTwo:null,
       mode: "default", // or 'simple'
      toolbarConfig: {
        excludeKeys: ["todo", "emotion"],
      },
      editorConfig: {
        hoverbarKeys: {
          attachment: {
            menuKeys: ["downloadAttachment"], // “下载附件”菜单
          },
        },
        MENU_CONF: {
          uploadAttachment: {
            // 用户自定义上传
            customUpload(file, insertFn) {
               self.loadingBox = true;
              uploadImg(file, "fujian").then((res) => {
                self.loadingBox = false;
                var encodedData = window.btoa(
                  process.env.VUE_APP_Img_Ip + res.path
                ); // 编码
                let url =
                  `${process.env.VUE_APP_Preview}?url=` + encodedData;
                insertFn(`${file.name}`, url);
              });
            },
          },
          fontFamily: {
            fontFamilyList: [
              "仿宋_GB2312",
              "黑体",
              "仿宋",
              "楷体",
              "标楷体",
              "华文仿宋",
              "华文楷体",
              "宋体",
              "微软雅黑",
              "Arial",
              "Tahoma",
              "Verdana",
              "Times New Roman",
              "Courier New",
            ],
          },
          uploadImage: {
            server:
              `${process.env.VUE_APP_BASE_URL}/site-service/m/cover/uploadImage`,
            fieldName: "file",
            meta: {
              type: "img",
            },
            headers: {
              token: sessionStorage.getItem("token"),
            },
            customInsert: this.customInsert,
             onProgress(progress) {  // TS 语法
                  self.loadingBox = true;
              },
              onSuccess(file, res) {  // TS 语法
                  self.loadingBox = false;
              },
              onFailed(file, res) {   
                self.loadingBox = false;
            },
          },
          fontSize:{
            fontSizeList:[
              { name: '初号', value: '56px' },
              { name: '小初', value: '48px' },
              { name: '一号', value: '34px' },
              { name: '小一', value: '32px' },
              { name: '二号', value: '29px' },
              { name: '小二', value: '24px' },
              { name: '三号', value: '21px' },
              { name: '小三', value: '20px' },
              { name: '四号', value: '18px' },
              { name: '小四', value: '16px' },
              { name: '五号', value: '14px' },
              { name: '小五', value: '12px' },
            ]
          },
          lineHeight:{
                lineHeightList: ['1', '1.5', '2', '2.5','3']
          },
          // uploadVideo: {
          //   server:
          //     `${process.env.VUE_APP_BASE_URL}/site-service/m/cover/uploadImage`,
          //   fieldName: "file",
          //   meta: {
          //     type: "video",
          //   },
          //   headers: {
          //     token: sessionStorage.getItem("token"),
          //   },
          //   customInsert: this.customInsert,
          //    maxFileSize:100* 1024 * 1024 * 1024,
          //   timeout: 60 * 60 * 1000,
          //   // 上传错误，或者触发 timeout 超时
          //   onError(file, err, res) {  // TS 语法
          //   // onError(file, err, res) {               // JS 语法
          //       console.log(`${file.name} 上传出错`, err, res)
          //   },
          //   // 单个文件上传成功之后
          //   onSuccess(file, res) {  // TS 语法
          //       console.log(`${file.name} 上传成功`, res)
          //       self.loadingBox = false;
          //   },
          //   onBeforeUpload(file) {   // TS 语法
          //         return file
          //     },
          //      onProgress(progress) {  // TS 语法
          //        self.loadingBox = true;
          //     },
          // },
          uploadVideo:{
            maxFileSize:100* 1024 * 1024 * 1024,
            timeout: 60 * 60 * 1000,
            customUpload(file, insertFn) {  // TS 语法
            self.loadingBox = true;
                uploadVideo(file, "video").then((res) => {
                  if(res.video.path){
                     self.loadingBox = false;
                      insertFn(self.imgIp + res.video.path, self.imgIp + res.image.path)
                  }
              });
               
            }
          }
        },
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 200,
        pageSizeOptions: ["10", "20", "30"],
      },
      jsonContent:[
        {
          type: 'paragraph',
          lineHeight: '1.5',
          children: [
            { text: '', fontFamily: '宋体', fontSize: '18px' }
          ]
        },
    ],
      columns: [
        {
          title: "姓名",
          dataIndex: "userName",
          ellipsis: true,
          width: 120,
        },
         {
          title: "标题",
          dataIndex: "title",
          ellipsis: true,
           customCell: column => {
                        return {
                        style: {
                            'min-width': "120px",
                            'max-width': "320px",
                        }
                    };
                    },
                    customHeaderCell: column => {
                    return {
                        style: {
                            'min-width': "120px",
                            'max-width': "320px",
                        }
                    };
                    }
        },
        {
          title: "手机号",
          dataIndex: "userPhone",
          ellipsis: true,
          width: 120,
        },
        {
          title: "身份证号",
          dataIndex: "identityCard",
          ellipsis: true,
          width: 200,
        },
        {
          title: "提交时间",
          dataIndex: "submitTime",
          ellipsis: true,
          width: 200,
        },
        {
          title: "留言内容",
          dataIndex: "opinionDetails",
          ellipsis: true,
           customCell: column => {
                        return {
                        style: {
                            'min-width': "320px",
                            'max-width': "660px",
                        }
                    };
                    },
                    customHeaderCell: column => {
                    return {
                        style: {
                            'min-width': "320px",
                            'max-width': "660px",
                        }
                    };
                    }
        },
      ],
      dataSource: [],
      isCollectId: "",
      loading: false,
      height: 0,
      accessoryList: [""],
      feedbackAccessoryList: [""],
      codeData:[],
      heightTwo:0,
      txtUpdate:'',
      activeName:'first',
      txtUpdateTwo:'',
      loadingSubmintTwo:false,
    };
  },
  mounted() {
    if (this.$route.query.isCollectId) {
      this.isCollectId = Number(this.$route.query.isCollectId);
      this.isEdit = this.$route.query.isEdit;
      this.getCollectDetils();
    }
    this.toolbarConfig = {
      excludeKeys: ["todo", "emotion"],
      insertKeys: {
        index: 2, // 自定义插入的位置
        keys: ["uploadAttachment"], // “上传附件”菜单
      },
    };
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
    this.heightTwo = (document.documentElement.clientHeight - 360) + 'px';
    this.height = document.documentElement.clientHeight - 360;
    window.onresize = () => {
      return (() => {
        this.heightTwo = (document.documentElement.clientHeight - 360) + 'px';
        this.height = document.documentElement.clientHeight - 360;
      })();
    };
  },
  methods: {
    deletFile(index){
        this.accessoryList[index] = '';
        this.accessoryList = JSON.parse(JSON.stringify(this.accessoryList))
    },
 handleClick(){
        if(this.activeName == 'first'){
            this.type = 1;
            this.changeType(1)
        }
         if(this.activeName == 'second'){
            this.type = 2;
            this.changeType(2)
        }
         if(this.activeName == 'third'){
            this.type = 3;
            this.changeType(3)
        }
      },
    ueditorReady(editor) {
      this.editor = editor;
      // this.editor.setContent(this.txtUpdate);
      //editor.placeholder('<span style="color:#999">正文</span>')
      this.editor.addListener("fullscreenchanged", function(t, enabled) {
        if(!enabled){
          editor.unsetFloating();
        }else{
          document.getElementsByClassName("edui-editor-iframeholder")[0].style.maxHeight="100vh";
          document.getElementsByTagName("iframe")[0].style.maxHeight="100vh";
        }
      });
    },
     ueditorReadyTwo(editor) {
      this.editorTwo = editor;
      // this.editor.setContent(this.txtUpdate);
      //editor.placeholder('<span style="color:#999">正文</span>')
      this.editorTwo.addListener("fullscreenchanged", function(t, enabled) {
        if(!enabled){
          editor.unsetFloating();
        }
      });
    },

    beforeUpload(file, index) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (["pdf", "docx", "xlsx","zip","xls","doc","ppt","pptx"].indexOf(fileSuffix) == -1) {
        this.$message.error("请上传 pdf、docx、xlsx、zip、xls、doc、ppt、pptx 格式!");
        return;
      }
      uploadImg(file, "site_setting").then((res) => {
        this.accessoryList[index] = {name:res.name,url:res.path};
        this.accessoryList = JSON.parse(JSON.stringify(this.accessoryList));
      });
      return false;
    },
    beforeUploadTwo(file, index) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (["pdf", "docx", "xlsx","zip","xls","doc","ppt","pptx"].indexOf(fileSuffix) == -1) {
        this.$message.error("请上传 pdf、docx、xlsx、zip、xls、xlsx、doc、ppt、pptx 格式!");
        return;
      }
      uploadImg(file, "site_setting").then((res) => {
        this.feedbackAccessoryList[index] = {url:res.path,name:res.name};
        this.feedbackAccessoryList = JSON.parse(
          JSON.stringify(this.feedbackAccessoryList)
        );
      });
      return false;
    },
    toBack() {
      this.$router.push({
        path: "/index/interaction/solicitation_survey",
      });
    },
    onCreated(editor) {
      let a = (this.editor = Object.seal(editor)); // 一定要用 Object.seal() ，否则会报错
       this.$nextTick(() => {
        this.editor.select([]);
        this.editor.deleteFragment();
        this.editor.dangerouslyInsertHtml(this.txtUpdate);
      });
    },
     onCreatedTwo(editor) {
      let b = (this.editorTwo = Object.seal(editor)); // 一定要用 Object.seal() ，否则会报错
       this.$nextTick(() => {
        this.editorTwo.select([]);
        this.editorTwo.deleteFragment();
        this.editorTwo.dangerouslyInsertHtml(this.txtUpdateTwo);
      });
    },
    changeType(type) {
      this.type = type;
      if (type == 2) {
        this.opinionListPage();
      }
      if (type == 3) {
        this.editor = null;
        this.getCollectFeedback();
      }
    },
    opinionListPage() {
      const _this = this;
      _this.loading = true;
      let reqData = {
        isCollectId: _this.isCollectId,
        current: _this.pagination.current,
        size: _this.pagination.pageSize,
      };
      opinionFindListPage(reqData).then((res) => {
        if (res.code == 0) {
          _this.dataSource = res.data.records;
          _this.pagination.current = res.data.current;
          _this.pagination.total = res.data.total;
          _this.pagination.pageSize = res.data.size;
          _this.loading = false;
        }
      });
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.opinionListPage();
    },
    handleSizeChange(pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.opinionListPage();
    },
    getCollectDetils() {
      collectDetils({ id: this.isCollectId }).then((res) => {
        if (res.code == 0) {
           this.txtUpdate = res.data.collectContent;
           this.txtUpdateTwo = res.data.feedbackDetails;
          // if (this.editor) {
          //   this.$nextTick(() => {
          //     this.editor.select([]);
          //     this.editor.deleteFragment();
          //     this.editor.dangerouslyInsertHtml(this.txtUpdate);
          //   });
          // }
          // if (this.editorTwo) {
          //   this.$nextTick(() => {
          //     this.editorTwo.select([]);
          //     this.editorTwo.deleteFragment();
          //     this.editorTwo.dangerouslyInsertHtml(this.txtUpdateTwo);
          //   });
          // }
          this.collectForm = res.data;
          this.collectForm.collectTime = [
            new Date(this.collectForm.collectStartTime),
            new Date(this.collectForm.collectEndTime),
          ];
          this.accessoryList = JSON.parse(this.collectForm.accessory);
        }
      });
    },
    customInsert(res, insertFn) {
      let url = this.imgIp + res.data.path;
      let alt = res.data.name;
      insertFn(url, alt, "");
    },
    addAccessory() {
      this.accessoryList.push("");
    },
    deleteAccessory(index) {
      this.accessoryList.splice(index, 1);
    },
    addFeedbackAccessory() {
      this.feedbackAccessoryList.push("");
    },
    deleteFeedbackAccessory(index) {
      this.feedbackAccessoryList.splice(index, 1);
    },
    changeTime(){
      this.collectForm = JSON.parse(JSON.stringify(this.collectForm ))
    },
    //保存征集数据
    saveCollect() {
      
      this.$refs.collectForm.validate((valid) => {
              if(valid){
                  const _this = this;
      this.loadingSubmint = true;
      let reqData = { ..._this.collectForm };
      reqData.accessory = JSON.stringify(_this.accessoryList);
      if(reqData.collectStartTime){
        reqData.collectStartTime = _this.farmatDate(
        new Date(_this.collectForm.collectTime[0].toString()).getTime(),
        "-"
      );
      }
      if(reqData.collectEndTime){
        reqData.collectEndTime = _this.farmatDate(
        new Date(_this.collectForm.collectTime[1].toString()).getTime(),
        "-"
      );
      }
      
      if (typeof _this.collectForm.issueTime != "string") {
        if(reqData.issueTime){
            reqData.issueTime = _this.farmatDate(
          new Date(_this.collectForm.issueTime.getTime()),
          "-"
        );
        }
      }
      reqData.siteId = sessionStorage.getItem("siteId");
      if (_this.isEdit) {
        updateCollect(reqData).then((res) => {
          if (res.code == 0) {
            message.success(res.msg);
            _this.getCollectDetils();
            _this.loadingSubmint = false;
          }else{
             _this.loadingSubmint = false;
          }
        });
      } else {
        if(reqData.collectTime){
              reqData.collectStartTime = _this.farmatDate(
                  new Date(reqData.collectTime[0].toString()).getTime(),
                  "-"
                );

               reqData.collectEndTime = _this.farmatDate(
                new Date(reqData.collectTime[1].toString()).getTime(),
                "-"
              );
              delete reqData.collectTime;
          }
        saveCollect(reqData).then((res) => {
          if (res.code == 0) {
            _this.isEdit = true;
            _this.isCollectId = res.data.id;
            message.success(res.msg);
            _this.getCollectDetils();
            _this.loadingSubmint = false;
          }else{
             _this.loadingSubmint = false;
          }
        });
      }
              }
            })
      
    },
    farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
    getCollectFeedback() {
      collectFeedback({ id: this.isCollectId }).then((res) => {
        if (res.code == 0) {
          if (res.data != null) {
            this.collectFeedbackForm = res.data;
            this.feedbackAccessoryList =
              JSON.parse(this.collectFeedbackForm.accessory);
          }
        }
      });
    },
    saveFeedback() {
      const _this = this;
      this.$refs.ruleForm.validate((valid) => {
        if(valid){
            this.loadingSubmintTwo = true;
      let reqData = { ..._this.collectFeedbackForm };
      reqData.accessory = JSON.stringify(_this.feedbackAccessoryList);
      if(_this.collectFeedbackForm.issueTime){
          if(typeof _this.collectFeedbackForm.issueTime != "string"){
          reqData.issueTime = _this.farmatDate(
        new Date(_this.collectFeedbackForm.issueTime.getTime()),
        "-"
      );
      }
      }
      reqData.isCollectId = _this.isCollectId;
      if (reqData.id) {
        updateCollectFeedback(reqData).then((res) => {
          if (res.code == 0) {
            message.success(res.msg);
            _this.getCollectFeedback();
             _this.loadingSubmintTwo = false;
          }
        });
      } else {
        addCollectFeedback(reqData).then((res) => {
          if (res.code == 0) {
            message.success(res.msg);
            _this.getCollectFeedback();
             _this.loadingSubmintTwo = false;
          }
        });
      }
        }
      })
       
    },
    exportList() {
      this.exportShow = true;
      this.fileName = "";
    },
    tihuan(){
        IsCollectOpinionListExport({
            fileName:this.fileName,
            isCollectId:this.isCollectId,
        }).then((res)=>{
             this.exportShow = false;
        })
  }
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>
.top {
  padding: 24px;
  padding-bottom: 0px;
  .log-box {
    border-bottom: solid 1px #dcdfe6;
    display: flex;
    color: #000;
    .log {
      padding: 10px 20px;
      border-top: solid 1px #dcdfe6;
      border-left: solid 1px #dcdfe6;
      cursor: pointer;
    }
    .log:last-child {
      border-right: solid 1px #dcdfe6;
      border-top-right-radius: 10px;
    }
    .log:first-child {
      border-top-left-radius: 10px;
    }
  }
}
.head {
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #dcdfe6;
  padding: 18px 24px;
}
.content {
  .demo-ruleForm {
    //width: 600px;
    margin-top: 5px;
    padding-left: 24px;
  }
  .tips-text {
    font-size: 12px;
    // height: 20px;
    line-height: 26px;
    color: #9093a6;
  }
  /deep/ .el-form-item__content {
    margin-left: 100px !important;
  }
  /deep/ .el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 80px;
    border: none;
    img {
      width: 80px;
      height: 80px;
    }
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
    line-height: 80px;
  }
  .status {
    border: solid 1px #dcdfe6;
    border-radius: 4px;
    padding-left: 10px;
  }
}
.choose_template {
  /deep/.el-dialog__title {
    font-size: 16px;
    font-weight: bold;
  }
  /deep/.el-dialog {
    width: 36%;
  }
  .lod-tips {
    background: #f7f7f7;
    font-size: 12px;
    color: #928f8f;
    line-height: 36px;
    padding: 0 10px;
    border-radius: 4px;
  }
  .choose-path {
    line-height: 50px;
    padding: 0 10px;
    border-radius: 4px;
    border: solid 1px #dcdfe6;
    margin-top: 20px;
    box-sizing: border-box;
  }
  .template-list {
    border: solid 1px #dcdfe6;
    border-radius: 4px;
    margin-top: 20px;

    .title {
      background: #f7f7f7;
    }
    .item {
      font-weight: bold;
      line-height: 52px;
      box-sizing: border-box;
      border-bottom: solid 1px #dcdfe6;
      padding: 0 10px;
      &:last-child {
        border: none;
      }
    }
  }
}
.add-uplaod {
  width: 43px;
  height: 40px;
  background-color: #f6f6f6;
  border-radius: 4px;
  text-align: center;
  border: 1px solid #dcdfe6;
  margin-left: 10px;
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
  margin-bottom: 24px;
}
.column-box{
   /deep/ .el-dialog__body{
        padding-bottom: 0px;
    }
        /deep/ .el-dialog__title {
        font-weight: 600;
    }
    /deep/ .el-dialog__close {
    font-weight: 600;
    color: #000;
    }
}
.seting{
  display: flex;
  align-items: center;
  justify-content: center;
}
.zheng-ji{
  overflow-y: auto;
  padding: 24px;
}
.zhenji-seting{
  position: absolute;
  bottom: 0;
  padding: 24px;
}
.back{
  cursor: pointer;
}
/deep/ .ant-spin-container{
    position: initial;
}
/deep/ .ant-spin-nested-loading{
   position: initial;
}

/deep/ .edui-default .edui-editor-toolbarbox {
  position: sticky;
  top: -10px;
  z-index: 9999
}

/deep/ .edui-default .edui-editor-iframeholder, .edui-default .edui-editor-iframeholder iframe {
  max-height: 420px;
  height: 260px;
}
.el-button--primary {
  background: #176de6;
}
/deep/ .el-tabs__header{
  margin: 0px;
}
/deep/ .el-form-item__label{
  padding: 0 30px 0 0;
}
</style>